import { FAIcon, Theme, useTranslation } from '@nextgen-web-framework/all';
import styles from './FloatErrorMessage.module.scss';

interface FloatErrorMessagePropTypes {
  message: string;
  wrapperClass?: string;
}

const FloatErrorMessage = ({ wrapperClass, message }: FloatErrorMessagePropTypes) => {
  const t = useTranslation();
  return (
    <span
      role="presentation"
      aria-label="message"
      className={`${styles['float-input-message']} ${wrapperClass}`}
      data-testid="message-test-id"
    >
      {<FAIcon iconName={'square-exclamation'} theme={Theme.RED} className={styles['input-icon']} />}
      {<span className={styles['float-message']}>{t(message)} </span>}
    </span>
  );
};

export { FloatErrorMessage };
